import { memo, useState, useContext } from "react";
import { useMutation, ClientContext } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import { useDrop } from "react-dnd";
import { makeStyles, Typography } from "@material-ui/core";

import Tooltip from "@material-ui/core/Tooltip";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import styled from "styled-components";

const StyledTooltip = styled((props) => (
  <Tooltip classes={{ popper: props.className }} {...props} />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #ffffff;
    border-radius: 4;
    font-size: 14px;
    font-weight: 400px;
  }
`;
const useStyles = makeStyles({
  mainStyle: {
    color: "#212121",
    textAlign: "center",
  //  font: "10px Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 400,
    lineHeight: "normal",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textOverflow: "ellipsis",
    letterSpacing: "0.4px",
  },
    pStyle: {
      backgroundColor: "#E0E0E0",
      borderRadius: "50%",
      width: "35px", //38
      height: "35px", //38
      lineHeight: "45px",
      background: "#fff",
      color: "#000",
      justifyContent: "center",
      font: "7.5px Roboto, Helvetica, Arial, sans-serif", //8
      letterSpacing: '-0.05px',
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      marginBottom: "2px",
      marginTop: " 2px",
  },
  pointCnt: {
    display: "flex",
    padding: "1px 1px 0px 5px",
    minHeight: 10,
    position: "relative",
  },
  droppedCnt: {
    display: "flex",
    border: "1px solid #FFFFFF",
    color: "#212121",
    position: "relative",
    background: "#9FC6A3",
    borderRadius: 2,
    padding: "1px 1px 0px 0px",
    height: 17,
    width: 59,
    font: "8.5px Roboto, Helvetica, Arial, sans-serif",
    letterSpacing: "-0.3px",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "30px",
    position: "relative",
    cursor: "pointer",
  },
  pointValueCnt: {
    width: "24px",
    height: "24px",
    borderRadius: "24px",
    position: "absolute",
    top: "-5px",
    right: "-17px",
    background: "#4E83A2",
    color: "#FFFFFF",
    justifyContent: "center",
    textAlign: "center",
    font: "16px Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 700,
    lineHeight: 1.6
  },
  pointZeroValueCnt: {
    width: "24px",
    height: "24px",
    borderRadius: "24px",
    position: "absolute",
    top: "-5px",
    right: "-17px",
    background: "#C51800",
    color: "#FFFFFF",
    justifyContent: "center",
    textAlign: "center",
    font: "16px Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 700,
    lineHeight: 1.6
  },
});

export const Selection = memo(function Selection({
  accept,
  text,
  lastDroppedItem,
  height,
  width,
  img,
  onDrop,
}) {
  const classes = useStyles();
  const [pathname] = useState(window.location.pathname);
  const [{ isOver, canDrop }, drop] = useDrop({
    accept,
    drop: onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  const client = useContext(ClientContext);
  const navigate = useNavigate();

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`/lms/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate("/lms/signout");
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
    }
  };
  let name = "";
  if (lastDroppedItem) {
    let split = lastDroppedItem.name.split(" ");
    name =
      split[0] && split[1]
        ? split[0].charAt(0).toUpperCase() + ". " + split[1]
        : lastDroppedItem.name;
  }
  return (
    <div
      className={classes.mainStyle}
      style={{
        height,
        width,
        backgroundImage: `url(${img})`,
        //backgroundRepeat: "no-repeat",
        flexDirection: "column",
        //border: "1px solid white"
      }}
    >
      <div
        ref={drop}
        role="Selection"
        className={classes.mainStyle}
        style={{
          height: "100px",
          width: "100%",
          flexDirection: "column",
          //border: "1px solid black"
        }}
      >
        <div className={classes.pointCnt}>
          <p className={classes.pStyle}>{text}</p>
          {lastDroppedItem && lastDroppedItem.SPDetailsData &&(
            <StyledTooltip title={parseInt(lastDroppedItem.SPDetailsData.player)+
            " (Player) + " + parseInt(lastDroppedItem.SPDetailsData.post)+
            " (Post) + " +  parseInt(lastDroppedItem.SPDetailsData.position)+
            " (Position)"}>
              <div className={ parseInt(lastDroppedItem.SPDetailsData.player)+
                    parseInt(lastDroppedItem.SPDetailsData.position) +
                    parseInt(lastDroppedItem.SPDetailsData.post) !== 0 ?
                    classes.pointValueCnt : classes.pointZeroValueCnt}>
                <Typography
                  variant="body1"
                  style={{ fontWeight: 700,fontSize:16, lineHeight: 1.6, color: "#FFFFFF" }}
                >
                  { parseInt(lastDroppedItem.SPDetailsData.player)+
                    parseInt(lastDroppedItem.SPDetailsData.position) +
                    parseInt(lastDroppedItem.SPDetailsData.post)}
                </Typography>
              </div>
            </StyledTooltip>
          )}
        </div>
        {lastDroppedItem && (
          <div className={classes.droppedCnt}>
            <p style={{ paddingRight: "5px", margin: "2px" }}>
              {lastDroppedItem.jerseyNO} {lastDroppedItem.onFieldName}
            </p>
          </div>
        )}
      </div>
    </div>
  );
});
